export function receivePushStickyNotificationResponse(context, { payload }) {
    const { notification } = payload;
    const notifications = context.getMethodsOf('notifications');
    notifications.pushStickyNotification(notification);
}
